import React from "react";

import { Box, Link, TextField, Typography } from "@material-ui/core";
import { NavLink as RouterLink } from "react-router-dom";

import { FormHeader } from "@hubcapp/components";
import Button from "@ds-developer/button";

import { SignUpProps } from "./types";

const SignUp: React.FC<SignUpProps> = ({
  errors,
  handleSubmit,
  handleADIEvent,
  handleMobileNoEvent,
  handleAccessCodeEvent,
  handleSignInEvent,
  isValid,
  loading = false,
  register,
  primaryErrorMessage,
  signInPath,
  brand,
}) => (
  <form onSubmit={handleSubmit}>
    <FormHeader
      title="Set a new password"
      subtitle={
        primaryErrorMessage
          ? primaryErrorMessage
          : "We will text you a one-time access code to set a new password to login."
      }
      error={Boolean(primaryErrorMessage)}
    />
    <TextField
      error={Boolean(errors?.adiNumber)}
      fullWidth
      helperText={errors?.adiNumber?.message}
      id="adiNumber"
      inputRef={register}
      // TODO: Fix
      label={`Your ${
        brand !== undefined ? brand.toUpperCase() : ""
      } instructor ID`}
      name="adiNumber"
      inputProps={{
        inputMode: "decimal",
        className: "data-hj-allow",
      }}
      type="text"
      variant="outlined"
      FormHelperTextProps={{
        // @ts-ignore
        ["data-test"]: "adiNumber-helper-text",
      }}
      onClick={handleADIEvent}
    />
    <TextField
      error={Boolean(errors?.mobileNumber)}
      fullWidth
      helperText={errors?.mobileNumber?.message}
      id="mobileNumber"
      inputRef={register}
      label="Registered mobile number"
      margin="normal"
      name="mobileNumber"
      type="tel"
      variant="outlined"
      FormHelperTextProps={{
        // @ts-ignore
        ["data-test"]: "mobileNumber-helper-text",
      }}
      onClick={handleMobileNoEvent}
    />
    <Box marginTop={2} marginBottom={2}>
      <Button
        disabled={!isValid || loading}
        color="primary"
        variant="contained"
        type="submit"
        size="large"
        loading={loading}
        data-test="submit-button"
        onClick={handleAccessCodeEvent}
      >
        Get access code
      </Button>
    </Box>

    <Typography variant="body1" color="textSecondary">
      Have an account?{" "}
      <Link to={signInPath} component={RouterLink} onClick={handleSignInEvent}>
        Sign in
      </Link>
    </Typography>
  </form>
);

export default SignUp;
